<template>
	<div class="image-box" :class="{ blank: !value }">
		<img v-if="value" class="image" :src="value" @click="clickInput" />
		<div v-if="!value" class="image" @click="clickInput">
			<div class="inner-box">
				<div class="text-extra-muted" v-if="!loading">Click to choose an image</div>
			</div>
		</div>
		<div class="loading" v-if="loading">
			<loading type="icon" />
		</div>
		<input
			id="image-input"
			class="d-none"
			type="file"
			accept=".bmp,.jpeg,.jpg,.png,.svg,.tiff,.webp"
			@change="pickImage"
		/>
	</div>
</template>

<style scoped>
.image-box {
	position: relative;
	padding: 2px;
	border-radius: 2px;
	border: 1px solid #e0e0e0;
	background-color: #ffffff;
}
.image-box:hover {
	filter: brightness(95%);
}
.image {
	width: 100px;
	height: 100px;
}
.blank .image {
	padding: 8px;
}
.blank .image .inner-box {
	width: 84px;
	height: 84px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 8px;
	border: 2px dashed lightblue;
	text-align: center;
	line-height: 1.2;
}
.loading {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 40px;
}
</style>

<script>
import ImageService from "@/services/ImageService";
import Notie from "@/services/NotieService";
import $ from "jquery";

export default {
	name: "ImagePicker",
	props: ["value"],

	data() {
		return {
			loading: false
		};
	},
	created() {},
	watch: {},

	computed: {},

	computer: {},
	methods: {
		pickImage(event) {
			if (!event.target.files || !event.target.files[0]) {
				console.log(event);
				console.log("Failed to pick file");
			}
			this.loading = true;
			ImageService.addImage(event.target.files[0])
				.then(resp => {
					console.log(resp.data);
					this.$emit("input", resp.data);
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to upload image", err);
				})
				.finally(() => {
					this.loading = false;
				});
		},

		clickInput() {
			$("#image-input").click();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/ImagePicker.vue